import React, { useState, useEffect } from "react";
import { Alert, ScrollView, Platform, View } from "react-native";
import * as Updates from "expo-updates";
import Constants from "expo-constants";

import config from "../config/config";
import useUser from "../hooks/useUser";
import ListItem from "../components/lists/ListItem";
import Screen from "../components/Screen";
import Icon from "../components/Icon";
import routes from "../navigation/routes";
import BlockSeperator from "../components/BlockSeperator";
import IconTouchable from "../components/IconTouchable";

function AccountScreen({ navigation }) {
    const { user, logOut } = useUser();

    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [message, setMessage] = useState(false);

    useEffect(() => {
        if (Platform.OS !== "web") {
            checkForUpdate();
        }
    }, []);

    const checkForUpdate = async () => {
        if (Constants.appOwnership == "expo") {
            return;
        }
        const update = await Updates.checkForUpdateAsync();
        if (update.isAvailable) {
            setUpdateAvailable(true);
        }
    };

    const handleUpdate = async () => {
        setMessage("Downloading...");
        const update = await Updates.fetchUpdateAsync();
        if (update.isNew) {
            await Updates.reloadAsync();
        }
    };

    return (
        <Screen title={"Account"} navigation={navigation} message={message} setMessage={setMessage}>
            <ScrollView>
                <ListItem title={user.name} subTitle={user.email} IconComponent={<Icon name="account" />} />
                <ListItem
                    title="Change Password"
                    IconComponent={<Icon name="lock-reset" />}
                    onPress={() => navigation.navigate(routes.CHANGE_PASSWORD)}
                    utilityComponent={<Icon name="arrow-right" backgroundColor={config.colors.white} iconColor={config.colors.tertiary} />}
                />

                <ListItem title="Log Out" IconComponent={<Icon name="logout" backgroundColor={config.colors.yellow} />} onPress={() => logOut()} />
                <ListItem
                    title={config.versionNo}
                    utilityComponent={
                        updateAvailable && (
                            <IconTouchable name="arrow-up" text="Update Available " flexDirection="row" textColor={config.colors.black} onPress={handleUpdate}></IconTouchable>
                        )
                    }
                />
                <BlockSeperator />
            </ScrollView>
        </Screen>
    );
}

export default AccountScreen;
